import "./CoworkingSpace.module.css";
import Header from "@/reusable_sections/Header";
import WelcomeToOurExpertise from "./sections/WelcomeToOurExpertise";
import RoomTour from "./sections/RoomTour";
import Gallery from "./sections/Gallery";
import CurrentTopics from "./sections/CurrentTopics";
import AccommodationDetail from "./sections/AccommodationDetail";
import Pricing from "./sections/Pricing";
import WebDesignerValue from "./sections/WebDesignerValue";
import AboutBluvit from "./sections/AboutBluvit";
import JetztBeitragBerechnen from "./sections/JetztBeitragBerechnen";
import Footer from "@/reusable_sections/Footer";
export default function CoworkingSpacePage() {
  return <div>
      <Header />
      <WelcomeToOurExpertise />
      <RoomTour />
      <Gallery />
      <CurrentTopics />
      <AccommodationDetail />
      <Pricing />
      <WebDesignerValue />
      <AboutBluvit />
      <JetztBeitragBerechnen />
      <Footer />
    </div>;
}